var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackIosBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_back_ios",
    clipPath: "url(#clip0_1918_1443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6196 2.99055C16.1296 2.50055 15.3396 2.50055 14.8496 2.99055L6.53957 11.3005C6.14957 11.6905 6.14957 12.3205 6.53957 12.7105L14.8496 21.0205C15.3396 21.5105 16.1296 21.5105 16.6196 21.0205C17.1096 20.5305 17.1096 19.7405 16.6196 19.2505L9.37957 12.0005L16.6296 4.75055C17.1096 4.27055 17.1096 3.47055 16.6196 2.99055Z",
    fill: "#292929"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1918_1443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackIosBlack);
export default __webpack_public_path__ + "static/media/arrow_back_ios_black.29cf42e2882026c51101efea9b72e0c2.svg";
export { ForwardRef as ReactComponent };